import useSWR from 'swr';
import axios from 'axios';

export const useRegions = ()=> {
    const { data, isLoading } = useSWR('erdb/region', axios.get)
    const { data: dataList } = useSWR('region/list', axios.get)
    return {
        data,
        isLoading,
        dataList,
    }
}
